/**
 * Dynamic Brands & Repairs Listing - JavaScript Query Parameter Handler
 * With robust error handling and IDE reload support
 */

(function() {
  'use strict';

  // Debug mode (set to false in production)
  const DEBUG = false;
  
  function log(...args) {
    if (DEBUG) console.log('[DynamicListings]', ...args);
  }

  // Parse URL parameters from browser
  function getQueryParam(param) {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    } catch (e) {
      console.error('[DynamicListings] Error parsing URL params:', e);
      return null;
    }
  }

  // Initialize brands listing page
  function initBrandsListing() {
    const container = document.querySelector('.dynamic-brands-listing');
    if (!container) {
      log('Brands container not found');
      return;
    }

    log('Initializing brands listing');

    const brandName = getQueryParam('name');
    log('Brand param:', brandName);
    
    if (!brandName) {
      showEmptyState(container, 'brand');
      return;
    }

    // Normalize brand name for filtering
    const normalizedBrand = normalizeBrand(brandName);
    log('Normalized brand:', normalizedBrand);

    // Update header with brand name
    const brandNameSpan = container.querySelector('#brand-name');
    const brandDescription = container.querySelector('#brand-description');
    
    if (brandNameSpan) {
      brandNameSpan.textContent = capitalizeFirst(brandName);
    }
    
    if (brandDescription) {
      brandDescription.textContent = `Wähle dein ${capitalizeFirst(brandName)}-Gerät und die gewünschte Reparatur aus.`;
    }
    
    // Filter products by brand
    filterRepairCards(container, normalizedBrand);
    
    // Initialize category filters
    initCategoryFilters(container, normalizedBrand);
  }

  // Initialize category filter buttons
  function initCategoryFilters(container, brandName) {
    const filterBtns = container.querySelectorAll('.filter-btn');
    log('Found filter buttons:', filterBtns.length);
    
    filterBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Update active state
        filterBtns.forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        
        const category = this.getAttribute('data-category');
        log('Filter clicked:', category);
        filterByCategory(container, brandName, category);
      });
    });
  }

  // Filter by category
  function filterByCategory(container, brandName, category) {
    const cards = container.querySelectorAll('.repair-listing-card');
    let visibleCount = 0;

    log(`Filtering ${cards.length} cards for brand: ${brandName}, category: ${category}`);

    cards.forEach(card => {
      const cardBrand = (card.getAttribute('data-brand') || '').toLowerCase().trim();
      const cardCategory = (card.getAttribute('data-category') || '').toLowerCase();
      
      const brandMatch = cardBrand === brandName;
      const categoryMatch = category === 'alle' || cardCategory === category;
      
      if (brandMatch && categoryMatch) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    log('Visible cards:', visibleCount);

    // Show/hide empty state
    const grid = container.querySelector('.repairs-grid');
    if (visibleCount === 0) {
      showEmptyState(container, 'brand', brandName);
      if (grid) grid.style.display = 'none';
    } else {
      hideEmptyState(container);
      if (grid) grid.style.display = '';
    }
  }

  // Filter repair cards by brand (initial)
  function filterRepairCards(container, brandName) {
    const cards = container.querySelectorAll('.repair-listing-card');
    let visibleCount = 0;

    log(`Filtering ${cards.length} repair cards for brand: ${brandName}`);

    cards.forEach(card => {
      const cardBrand = (card.getAttribute('data-brand') || '').toLowerCase().trim();
      log(`Card brand: ${cardBrand}, match: ${cardBrand === brandName}`);
      
      if (cardBrand === brandName) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    log('Visible repair cards:', visibleCount);

    // Show/hide grid based on results
    const grid = container.querySelector('.repairs-grid');
    if (visibleCount === 0) {
      showEmptyState(container, 'brand', brandName);
      if (grid) grid.style.display = 'none';
    } else {
      if (grid) grid.style.display = '';
      hideEmptyState(container);
    }
  }

  // Initialize repairs listing page
  function initRepairsListing() {
    const container = document.querySelector('.dynamic-repairs-listing');
    if (!container) {
      log('Repairs container not found');
      return;
    }

    log('Initializing repairs listing');

    const repairName = getQueryParam('name');
    log('Repair param:', repairName);
    
    if (!repairName) {
      showEmptyState(container, 'repair');
      return;
    }

    // Update header with repair name
    const repairNameSpan = container.querySelector('#repair-name');
    const repairDescription = container.querySelector('#repair-description');
    
    if (repairNameSpan) {
      repairNameSpan.textContent = capitalizeFirst(repairName);
    }
    
    if (repairDescription) {
      repairDescription.textContent = `Wähle dein Gerät für die ${capitalizeFirst(repairName)}-Reparatur aus.`;
    }
    
    // Filter devices
    filterDevices(container, repairName.toLowerCase());
    
    // Initialize category filters for repair page too
    initRepairCategoryFilters(container, repairName.toLowerCase());
  }

  // Initialize category filter buttons for repair page
  function initRepairCategoryFilters(container, repairName) {
    const filterBtns = container.querySelectorAll('.filter-btn');
    log('Found filter buttons:', filterBtns.length);
    
    filterBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Update active state
        filterBtns.forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        
        const category = this.getAttribute('data-category');
        log('Filter clicked:', category);
        filterDevicesByCategory(container, repairName, category);
      });
    });
  }

  // Filter by category on repair page
  function filterDevicesByCategory(container, repairName, category) {
    const cards = container.querySelectorAll('.repair-listing-card');
    let visibleCount = 0;

    log(`Filtering ${cards.length} cards for repair: ${repairName}, category: ${category}`);

    cards.forEach(card => {
      const cardCategory = (card.getAttribute('data-category') || '').toLowerCase();
      
      const repairMatch = cardMatchesRepair(card, repairName);
      const categoryMatch = category === 'alle' || cardCategory === category;
      
      if (repairMatch && categoryMatch) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    log('Visible cards:', visibleCount);

    // Show/hide empty state
    const grid = container.querySelector('.devices-grid');
    if (visibleCount === 0) {
      showEmptyState(container, 'repair', repairName);
      if (grid) grid.style.display = 'none';
    } else {
      hideEmptyState(container);
      if (grid) grid.style.display = '';
    }
  }

  // Filter devices by repair type
  function filterDevices(container, repairName) {
    const grid = container.querySelector('.devices-grid');
    if (!grid) {
      log('Devices grid not found');
      return;
    }

    const cards = grid.querySelectorAll('.repair-listing-card');
    let visibleCount = 0;

    log(`Filtering ${cards.length} device cards for repair: ${repairName}`);

    cards.forEach(card => {
      const match = cardMatchesRepair(card, repairName);
      log(`Card repair match: ${match}`);
      
      if (match) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    log('Visible device cards:', visibleCount);

    // Show/hide grid based on results
    if (visibleCount === 0) {
      showEmptyState(container, 'repair', repairName);
      grid.style.display = 'none';
    } else {
      grid.style.display = '';
      hideEmptyState(container);
    }
  }

  // Show empty state message
  function showEmptyState(container, type, name) {
    let emptyState = container.querySelector('.empty-state');
    
    if (!emptyState) {
      emptyState = document.createElement('div');
      emptyState.className = 'empty-state';
      const containerEl = container.querySelector('.container');
      if (containerEl) {
        containerEl.appendChild(emptyState);
      } else {
        container.appendChild(emptyState);
      }
    }

    const heading = document.createElement('h3');
    
    const text = document.createElement('p');

    if (!name) {
      heading.textContent = type === 'brand' ? 'Keine Marke ausgewählt' : 'Keine Reparatur ausgewählt';
      text.textContent = type === 'brand' 
        ? 'Bitte wähle eine Marke aus dem Footer-Menü.'
        : 'Bitte wähle eine Reparatur aus dem Footer-Menü.';
    } else {
      heading.textContent = 'Keine Produkte gefunden';
      text.textContent = type === 'brand'
        ? `Für ${capitalizeFirst(name)} sind aktuell keine Reparaturen verfügbar.`
        : `Für ${capitalizeFirst(name)}-Reparatur sind aktuell keine Geräte verfügbar.`;
    }

    emptyState.innerHTML = '';
    emptyState.appendChild(heading);
    emptyState.appendChild(text);
    emptyState.style.display = 'block';
    
    log('Empty state shown:', type, name);
  }

  // Hide empty state
  function hideEmptyState(container) {
    const emptyState = container.querySelector('.empty-state');
    if (emptyState) {
      emptyState.style.display = 'none';
    }
  }

  // Capitalize first letter
  function capitalizeFirst(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // Normalize brand name: lowercase and only first word
  function normalizeBrand(brand) {
    if (!brand) return '';
    return brand.toLowerCase().trim().split(/\s+/)[0];
  }

  function initVariantSelectors(root = document) {
    const cards = root.querySelectorAll('.repair-listing-card');
    if (!cards.length) return;

    const repairParam = window.location.pathname.includes('/pages/repairs')
      ? getQueryParam('name')
      : null;
    const preferredRepair = repairParam ? repairParam.toLowerCase() : '';

    cards.forEach(card => {
      const select = card.querySelector('[data-variant-select]');
      if (!select || select.dataset.bound === 'true') return;
      select.dataset.bound = 'true';

      const priceValue = card.querySelector('[data-price-value]');
      const priceLabel = card.querySelector('[data-price-label]');
      const variantTitle = card.querySelector('[data-variant-title]');
      const description = card.querySelector('[data-variant-description]');
      const inquiryWrapper = card.querySelector('[data-inquiry-wrapper]');
      const cartWrapper = card.querySelector('[data-cart-wrapper]');
      const cartInput = card.querySelector('[data-variant-id-input]');
      const inquiryLink = card.querySelector('.repair-inquiry-link');
      const availability = card.querySelector('[data-availability]');
      const availabilityText = card.querySelector('[data-availability-text]');
      const image = card.querySelector('[data-card-image]');
      const frameFields = card.querySelector('[data-frame-fields]');
      const frameInput = card.querySelector('[data-frame-input]');
      const displayNotice = card.querySelector('[data-display-notice]');

      const productImage = card.getAttribute('data-product-image') || '';
      const deviceTitle = card.getAttribute('data-device-title') || '';
      const contactUrl = card.getAttribute('data-contact-url') || '/pages/kontakt';

      const applySelection = () => {
        const option = select.selectedOptions ? select.selectedOptions[0] : null;
        if (!option) return;

        const price = parseFloat(option.dataset.price || '0');
        const priceFormatted = option.dataset.priceFormatted || '';
        const requiresInquiry = option.dataset.requiresInquiry === 'true';
        const available = option.dataset.available === 'true';
        const title = option.dataset.variantTitle || option.textContent.trim();
        const descriptionText = option.dataset.description || '';
        const imageUrl = option.dataset.image || productImage;

        if (variantTitle) variantTitle.textContent = title;

        if (description) {
          if (descriptionText) {
            description.textContent = descriptionText;
            description.classList.remove('hidden');
          } else {
            description.textContent = '';
            description.classList.add('hidden');
          }
        }

        if (priceValue) {
          if (price <= 0) {
            priceValue.textContent = 'Preis auf Anfrage';
            if (priceLabel) priceLabel.classList.add('hidden');
          } else {
            priceValue.textContent = priceFormatted || '';
            if (priceLabel) priceLabel.classList.remove('hidden');
          }
        }

        if (cartInput) cartInput.value = option.value;

        if (inquiryLink) {
          const url = new URL(contactUrl, window.location.origin);
          url.searchParams.set('device', deviceTitle);
          url.searchParams.set('variant', title);
          url.searchParams.set('variant_id', option.value);
          inquiryLink.setAttribute('href', url.pathname + url.search);
        }

        if (inquiryWrapper && cartWrapper) {
          if (requiresInquiry) {
            inquiryWrapper.classList.remove('hidden');
            cartWrapper.classList.add('hidden');
          } else {
            inquiryWrapper.classList.add('hidden');
            cartWrapper.classList.remove('hidden');
          }
        }

        if (availability && availabilityText) {
          availabilityText.textContent = available ? 'Verfügbar' : 'Nicht verfügbar';
          availability.classList.toggle('text-green-600', available);
          availability.classList.toggle('text-red-600', !available);
          availability.dataset.available = available ? 'true' : 'false';
        }

        if (image && imageUrl) {
          image.src = imageUrl;
          image.alt = deviceTitle ? `${deviceTitle} - ${title}` : title;
        }

        // Frame Color Logic
        if (frameFields) {
          const lowerTitle = title.toLowerCase();
          const requiresFrameColor = lowerTitle.includes('backcover') || 
                                     lowerTitle.includes('display') || 
                                     lowerTitle.includes('frontglas') ||
                                     lowerTitle.includes('rahmen') ||
                                     lowerTitle.includes('gehäuse');
                                     
          if (requiresFrameColor) {
            frameFields.classList.remove('hidden');
            if (frameInput) frameInput.required = true;
          } else {
            frameFields.classList.add('hidden');
            if (frameInput) frameInput.required = false;
          }
        }

        // Display Notice Logic
        if (displayNotice) {
          const lowerTitle = title.toLowerCase();
          const isDisplayWithFrame = lowerTitle.includes('display') && lowerTitle.includes('rahmen');
          
          if (isDisplayWithFrame) {
            displayNotice.classList.remove('hidden');
          } else {
            displayNotice.classList.add('hidden');
          }
        }
      };

      if (preferredRepair) {
        const match = Array.from(select.options).find(option => {
          const title = (option.dataset.variantTitle || option.textContent || '').toLowerCase().trim();
          return title.includes(preferredRepair);
        });
        if (match) select.value = match.value;
      }

      select.addEventListener('change', applySelection);
      applySelection();
    });
  }

  function cardMatchesRepair(card, repairName) {
    const raw = (card.getAttribute('data-repair') || '').toLowerCase();
    if (!raw) return false;
    const repairs = raw.split('|').map(item => item.trim()).filter(Boolean);
    
    // Check for exact match first, then partial match
    // This allows "display" to match "display original" or "premium display"
    return repairs.some(item => item.includes(repairName));
  }

  // Initialize on page load
  function init() {
    log('Initializing dynamic listings');
    log('Current URL:', window.location.href);
    log('Pathname:', window.location.pathname);
    log('Search:', window.location.search);
    
    // Check if we're on brands or repairs page
    if (window.location.pathname.includes('/pages/brands')) {
      log('Detected brands page');
      // Wait a tiny bit to ensure DOM is fully ready
      setTimeout(() => initBrandsListing(), 10);
    } else if (window.location.pathname.includes('/pages/repairs')) {
      log('Detected repairs page');
      // Wait a tiny bit to ensure DOM is fully ready
      setTimeout(() => initRepairsListing(), 10);
    } else {
      log('Not on brands or repairs page');
    }

    setTimeout(() => initVariantSelectors(), 20);
  }

  // Run on DOM ready with multiple fallbacks
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM already loaded
    init();
  }

  // Also run on window load as fallback
  window.addEventListener('load', function() {
    // Only re-init if containers exist but are empty
    const brandsContainer = document.querySelector('.dynamic-brands-listing');
    const repairsContainer = document.querySelector('.dynamic-repairs-listing');
    
    if (brandsContainer) {
      const visibleCards = brandsContainer.querySelectorAll('.repair-listing-card:not([style*="display: none"])');
      if (visibleCards.length === 0 && getQueryParam('name')) {
        log('Re-initializing brands on window load');
        initBrandsListing();
      }
    }
    
    if (repairsContainer) {
      const visibleCards = repairsContainer.querySelectorAll('.repair-listing-card:not([style*="display: none"])');
      if (visibleCards.length === 0 && getQueryParam('name')) {
        log('Re-initializing repairs on window load');
        initRepairsListing();
      }
    }
  });

  // Handle Shopify theme editor events
  document.addEventListener('shopify:section:load', function(event) {
    log('Section loaded:', event.detail.sectionId);
    if (event.detail.sectionId.includes('dynamic_brands') || 
        event.detail.sectionId.includes('dynamic_repairs')) {
      setTimeout(init, 50);
    }
  });

  // Handle visibility change (tab switching)
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
      log('Tab became visible');
      // Re-check if we need to init
      const brandsContainer = document.querySelector('.dynamic-brands-listing');
      const repairsContainer = document.querySelector('.dynamic-repairs-listing');
      
      if ((brandsContainer || repairsContainer) && getQueryParam('name')) {
        setTimeout(init, 10);
      }
    }
  });

})();
